import { useState } from 'react';
import {
  UserFoto,
  UserMais,
  UserPlaceholder,
  UsersEmail,
  UsersItem,
  UsersName,
  UsersRank,
  UsersStatus,
} from './styles';
import DropdownSelection from '../../../components/general/DropdownSelection';
import { handleResendEmail } from '../../../state/users/actions';
import { useDispatch } from 'react-redux';
import { toastAlert } from '../../../components/Toastify/index';

const UsersDisplay = ({
  item,
  user,
  handleDelete,
  handleTurnColaborador,
  handleTurnGerente,
  index,
}) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const onClose = () => setOpen(false);

  const handleOptionClick = (option) => {
    switch (option.label) {
      case 'Tornar Colaborador':
        handleTurnColaborador(item);
        break;
      case 'Tornar Gerente':
        handleTurnGerente(item);
        break;
      case 'Reenviar convite':
        dispatch(handleResendEmail({ id: item._id }))
          .then(() => toastAlert({ msg: 'Email reenviado com sucesso!' }))
          .catch(() =>
            toastAlert({
              msg: 'Ocorreu um erro ao reenviar o email!',
              isError: true,
            })
          );
        break;
      case 'Excluir usuário':
        handleDelete(item);
        break;
      default:
        break;
    }
    onClose();
  };

  const renderDropdown = (open, setOpen) => {
    if (
      item._id === user._id ||
      item.rank === 'admin' ||
      user.rank === 'colaborador' ||
      (user.rank === 'gerente' &&
        (item.rank === 'admin' || item.rank === 'gerente'))
    ) {
      return null;
    }

    const options = [];

    if (user.rank === 'admin' && item.rank === 'gerente') {
      options.push({
        label: 'Tornar Colaborador',
        onClick: () => handleOptionClick({ label: 'Tornar Colaborador' }),
      });

      options.push({
        label: 'Excluir usuário',
        onClick: () => handleOptionClick({ label: 'Excluir usuário' }),
      });
    }

    if (user.rank === 'admin' && item.rank === 'colaborador') {
      options.push({
        label: 'Tornar Gerente',
        onClick: () => handleOptionClick({ label: 'Tornar Gerente' }),
      });

      options.push({
        label: 'Excluir usuário',
        onClick: () => handleOptionClick({ label: 'Excluir usuário' }),
      });
    }

    if (user.rank === 'gerente' && item.rank === 'colaborador') {
      options.push({
        label: 'Excluir usuário',
        onClick: () => handleOptionClick({ label: 'Excluir usuário' }),
      });
    }

    if (item.status === 'pending') {
      options.push({
        label: 'Reenviar convite',
        onClick: () => handleOptionClick({ label: 'Reenviar convite' }),
      });
    }

    return (
      <DropdownSelection
        options={options}
        actived={open}
        setActived={setOpen}
      />
    );
  };

  return (
    <UsersItem index={index}>
      <UserFoto>
        <UserPlaceholder src={item.avatarURL} />
      </UserFoto>
      <UsersName>{item.username}</UsersName>
      <UsersEmail>{item.email}</UsersEmail>
      <UsersRank>
        {item.rank === 'admin'
          ? 'Administrador'
          : item.rank === 'gerente'
          ? 'Gerente'
          : 'Colaborador'}
      </UsersRank>
      <UsersStatus status={item.status}>
        {item.status === 'pending' ? 'Convite enviado' : 'Ativo'}
      </UsersStatus>
      <UserMais>{renderDropdown(open, setOpen)}</UserMais>
    </UsersItem>
  );
};

export default UsersDisplay;
